import {Skill, SkillRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {useApiManager} from "../../../../components/utils/api";
import {TableCell} from "@mui/material";

export const SkillListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<Skill> = {
		title: "Listado de habilidades ",
		onClick: "/app/admin/recruitment/skill",
		headers: [
			{title: "Nombre"},
			{title: "Posición"},
			{title: "Mostrar en Formulario"},
		],
		decorator: (bean: Skill) => (
			<>
				<TableCell>
					{bean.label}
				</TableCell>
				<TableCell>
					{bean.position}
				</TableCell>
				<TableCell>
					{bean.showInForm ? "Sí" : ""}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(SkillRestControllerApiFactory);
			return ctrl.pageSkill(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};